import { render, staticRenderFns } from "./subSourcingFlow.vue?vue&type=template&id=a8c274f6&scoped=true"
import script from "./subSourcingFlow.vue?vue&type=script&lang=js"
export * from "./subSourcingFlow.vue?vue&type=script&lang=js"
import style0 from "./subSourcingFlow.vue?vue&type=style&index=0&id=a8c274f6&prod&lang=scss&scoped=true"
import style1 from "./subSourcingFlow.vue?vue&type=style&index=1&id=a8c274f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c274f6",
  null
  
)

export default component.exports